module.exports = __webpack_public_path__ + "media/assets/svgs/googleCalendarIcon-696814fcdb8a0a9018732060f1aa8c30.svg";